// import React from 'react';
// import PageTemplate from './PageTemplate';
// export default function PrivacyPolicy(props) { return <PageTemplate {...props} slug="privacy-policy" />; }

import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';

function PrivacyPolicy({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  const [activeSection, setActiveSection] = useState('intro');

  // পেজ লোড হলে একেবারে উপরে স্ক্রল করবে
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // সাইডবার থেকে ক্লিক করলে নির্দিষ্ট সেকশনে স্মুথ স্ক্রল করার ফাংশন
  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      // হেডার যেহেতু ফিক্সড, তাই স্ক্রল করার সময় কিছুটা উপর থেকে জায়গা ছাড়ার জন্য offset দেওয়া হলো
      const y = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  // সাইডবারের মেনু লিস্ট
  const sections = [
    { id: 'intro', title: '1. Introduction' },
    { id: 'collect', title: '2. Information We Collect' },
    { id: 'use', title: '3. How We Use Information' },
    { id: 'sharing', title: '4. Information Sharing' },
    { id: 'security', title: '5. Data Security' },
    { id: 'cookies', title: '6. Cookies Policy' },
    { id: 'contact', title: '7. Contact Us' },
  ];

  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      {/* 🚨 Page Banner 🚨 */}
      <div className="bg-[#002f34] py-16 px-6">
        <div className="max-w-[1200px] mx-auto text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-wide">Privacy <span className="text-[#ef5e33]">Policy</span></h1>
          <p className="text-gray-300 font-bold mt-4 text-sm md:text-base">
            Last Updated: March 2026 • Bah! Car Plaza
          </p>
        </div>
      </div>

      <main className="flex-1 max-w-[1200px] w-full mx-auto py-12 px-6">
        <div className="flex flex-col md:flex-row gap-10 items-start">
          
          {/* 🚨 LEFT SIDEBAR (Sticky Navigation like Spinny) 🚨 */}
          <aside className="w-full md:w-1/4 bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden sticky top-28 hidden md:block">
            <div className="p-6 bg-gray-50 border-b border-gray-100">
              <h3 className="font-black text-[#002f34] uppercase text-sm tracking-wider">Quick Links</h3>
            </div>
            <ul className="flex flex-col py-2">
              {sections.map((section) => (
                <li 
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className={`px-6 py-4 cursor-pointer text-sm font-bold transition-all duration-300 border-l-4 ${
                    activeSection === section.id 
                      ? 'border-[#ef5e33] bg-[#fff3ec] text-[#ef5e33]' 
                      : 'border-transparent text-gray-500 hover:bg-gray-50 hover:text-[#002f34]'
                  }`}
                >
                  {section.title}
                </li>
              ))}
            </ul>
          </aside>

          {/* 🚨 RIGHT CONTENT (Legal Document Style) 🚨 */}
          <div className="w-full md:w-3/4 bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12 text-gray-600 leading-relaxed text-sm md:text-base">
            
            <section id="intro" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">1. Introduction</h2>
              <p className="mb-4">
                Welcome to <strong className="text-[#002f34]">Bah! Car Plaza</strong>. We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website (https://bahcarplaza.com) or use our services to buy, sell, or inspect used cars.
              </p>
              <p>
                By accessing or using our platform, you agree to the terms outlined in this Privacy Policy. If you do not agree, please refrain from using our services.
              </p>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="collect" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">2. Information We Collect</h2>
              <p className="mb-4">We may collect several types of information from and about users of our Website, including:</p>
              <ul className="list-disc pl-6 space-y-3 mb-4">
                <li><strong>Personal Identification Data:</strong> Name, email address, phone number, and location details when you register or book a test drive.</li>
                <li><strong>Vehicle Information:</strong> Car registration number, make, model, year, and images if you list a car for sale.</li>
                <li><strong>Financial Data:</strong> Transaction histories and payment details processed securely through our payment partners.</li>
                <li><strong>Usage Data:</strong> Information about how you interact with our website, including IP addresses, browser types, and pages visited.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="use" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">3. How We Use Information</h2>
              <p className="mb-4">The information we collect is used in the following ways:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide, maintain, and improve our services.</li>
                <li>To process transactions, bookings, and vehicle inspections.</li>
                <li>To send administrative information, such as updates, security alerts, and support messages.</li>
                <li>To personalize user experience and recommend cars based on your preferences and location.</li>
                <li>To detect, prevent, and address technical issues or fraudulent activities.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="sharing" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">4. Information Sharing & Disclosure</h2>
              <p className="mb-4">We do not sell, trade, or rent your personal identification information to others. However, we may share information with:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Service Providers:</strong> Third-party vendors who assist us in operating our website, conducting inspections, or processing payments.</li>
                <li><strong>Legal Compliance:</strong> When required by law, court order, or government regulation.</li>
                <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="security" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">5. Data Security</h2>
              <p>
                We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
              </p>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="cookies" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">6. Cookies Policy</h2>
              <p>
                We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
              </p>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="contact" className="mb-4 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">7. Contact Us</h2>
              <p className="mb-4">
                If you have questions or comments about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-[#f9f9f9] p-6 rounded-2xl border border-gray-200">
                <p className="font-bold text-[#002f34] mb-1">Bah! Car Plaza Headquarters</p>
                <p className="mb-1">Rajpur Sonarpur, West Bengal, India</p>
                <p className="mb-1">Email: <a href="mailto:bahcarplaza@gmail.com" className="text-[#ef5e33] hover:underline">bahcarplaza@gmail.com</a></p>
                <p>Phone: <a href="tel:+919932014259" className="text-[#ef5e33] hover:underline">+91 9932014259</a></p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default PrivacyPolicy;